import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "climb-down",
  "use": "climb-down-usage",
  "viewBox": "-2 -6 24 24",
  "content": "<symbol viewBox=\"-2 -6 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"climb-down\">\r\n<path d=\"M14 12L16.29 9.71L11.41 4.83L7.41 8.83L0 1.41L1.41 0L7.41 6L11.41 2L17.71 8.29L20 6V12H14Z\" fill=\"#3A3A3A\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol